import { LoadingButton } from '@mui/lab'
import { Alert, Stack, TextField } from '@mui/material'
import { createUserPasswordLink } from 'api/users'
import { useCallback, useState } from 'react'
import { useMutation } from 'react-query'

interface UserPasswordSetupLinkProps {
  userId: number
  /** The link is tied to the saved email — generating one for an unsaved address would be wrong. */
  disabled?: boolean
}

export function UserPasswordSetupLink({ userId, disabled = false }: UserPasswordSetupLinkProps) {
  const linkMutation = useMutation(createUserPasswordLink)
  const [sent, setSent] = useState(false)
  const [link, setLink] = useState('')

  const handleCreate = useCallback(async () => {
    const response = await linkMutation.mutateAsync({ id: userId })
    const body = response.data
    if (body.link) {
      setLink(body.link)
      setSent(false)
      return
    }
    setLink('')
    setSent(true)
  }, [userId, linkMutation])

  return (
    <Stack spacing={2} alignItems="flex-start">
      <LoadingButton
        type="button"
        variant="contained"
        color="secondary"
        loading={linkMutation.isLoading}
        disabled={disabled}
        sx={{ width: '240px' }}
        onClick={handleCreate}
      >
        {link ? 'Create Password Setup Link' : 'Email Password Setup Link'}
      </LoadingButton>

      {sent && <Alert severity="success">The password setup link was emailed to this user.</Alert>}
      {link && (
        <TextField
          fullWidth
          label="Password setup link"
          value={link}
          InputProps={{ readOnly: true }}
          onFocus={(event) => event.target.select()}
        />
      )}
    </Stack>
  )
}
